export default {
  LIST: {
    TITLE: `Attendance list`,
    SUMMARY: ``
  },
  CREATE: `Create an attendance`,
  IN_PROGRESS: `In progress`,
  ACKNOWLEDGE: `Acknowledge`,
  ACKNOWLEDGED: `Acknowledged`,
  JUSTIFIED: `Justified`,
  UNJUSTIFIED: `Unjustified`,
  REFUSED: `Refused`,
  CANCELLED: `Cancelled`,
  IN_PROGRESS_MARKED: `Put in progress`,
  ACKNOWLEDGED_MARKED: `Acknowledged`,
  JUSTIFIED_MARKED: `Justified`,
  UNJUSTIFIED_MARKED: `Unjustified`,
  REFUSED_MARKED: `Refused`,
  CANCELLED_MARKED: `Cancelled`,
  STATUS: `Status`,
  MANAGEMENT: `Management`,
  TIME_PAID: `Paid hours`,
  CREATION_DATE: `Created on`,
  LAST_MODIFIED_DATE: `Modified on`,
  FIRST_COLUMN: ``,
  SECOND_COLUMN: ``,
  OVER_THRESHOLD: `over threshold`,
  CREATED_BY_ON: `Created by <0>{{createdBy}}</0> on {{date}} <2>{{time}}</2>`,
  STATUS_PHRASE: `<0>{{status}}</0> by <1>{{validateBy}}</1> on {{date}} <3>{{time}}</3>`,
  COMMENT: `<0>{{count}} comment <2/></0>`,
  COMMENT_other: `<0>{{count}} comments <2/></0>`,
  REASON_INFO: `Reason`,
  MADE_BY_PHONE: `Made over the phone: {{phone}}`,
  ABSENCE: `Absence`,
  LATENESS: `Late, arrives at {{time}}`,
  EARLYOUT: `Early out, left at {{time}}`,
  TRANSFERED_INTO_INTEGRATION: `Transfered into integration`,
  TRANSFER_INTO_INTEGRATION_FAILED: `Transfer into integration failed`,
  DELETE: {
    TITLE: `Delete the attendance request`,
    SUMMARY: `Are you sure you want to delete the attendance request?`,
    PRIMARY_ACTION: `Delete the request`
  },
  csv: {
    ATTENDANCE_CSV_NAME: `attendances_export_{{date}}`,
    REQUEST_DATE: `Request date`,
    CREATED_BY: `Created by`,
    VALIDATION_DATE: `Validation date`,
    VALIDATED_BY: `Validated by`,
    REQUEST_TYPE: `Request type`,
    COMMENTS: `Comments`,
    REASON: `Reason`,
    DATE: `Date`,
    START: `Start`,
    END: `End`,
    ARRIVAL_TIME: `Arrival time`,
    DEPARTURE_TIME: `Departure time`,
    REQUEST_STATUS: `Request status`,
    DEPARTMENTS: `Departments`,
    TEAMS: `Teams`,
    PROJECT: `Projects`,
    EMPLOYEE_NUMBER: `Employee number`,
    EMPLOYEE: `Employee`,
    ARCHIVED: `Archived`,
    STATUS: `Status`
  },
  TOTAL_ABSENCES_IN_BANK: `The user requested {{ totalAbsences }} absence(s) in the last {{ period }} days.`,
  TOTAL_ABSENCES_IN_BANK_MY_HOME: `You have requested {{ totalAbsences }} absence(s) in the last {{ period }} days.`,
  ABSENCE_OVER_THRESHOLD: `Absence over the threshold`,
  THIS_ABSENCE_WILL_BE_OVER_THRESHOLD: `This absence will be over the allowed threshold.`,
  form: {
    CREATE: {
      TITLE: `Create an attendance request`,
      SUMMARY: ``
    },
    EDIT: { TITLE: `Edit an attendance request`, SUMMARY: `` },
    DATE: {
      LABEL: `Date`
    },
    EVENTID: {
      LABEL: `Shift`,
      DESCRIPTION: `Select the shift to create an attendance request for.`,
      EMPTY_PLACEHOLDER: `Please select an employee, if an employee is selected they have no shift to create a request for.`
    },
    REQUESTTYPEID: {
      LABEL: `Request type`,
      DESCRIPTION: ``
    },
    REASONID: {
      LABEL: `Reason`,
      DESCRIPTION: ``
    },
    COMMENT: {
      LABEL: `Comment`,
      PLACEHOLDER: `Write a comment...`,
      DESCRIPTION: ``
    },
    ARRIVALTIME: {
      LABEL: `Arrival time`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    DEPARTURETIME: {
      LABEL: `Departure time`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    USERID: {
      LABEL: `Employee`,
      DESCRIPTION: ``
    },
    REQUESTSTATUSID: {
      LABEL: `Status`,
      DESCRIPTION: ``
    },
    NOT_LINKED_TO_SHIFT: `No shift found on selected date`,
    USER_REQUIRED: `The employee field is mandotory.`,
    COMMENT_REQUIRED: `The comment field is mandatory.`,
    SHIFT_REQUIRED: `The shift selection is mandatory.`,
    REQUEST_TYPE_ID_REQUIRED: `The request type selection is mandatory.`,
    REASON_ID_REQUIRED: `The reason selection is mandatory.`,
    ABSENCE: `Absence`,
    DELAY: `Late`,
    EARLY_OUT: `Early out`,
    SUBMIT: `Submit`,
    QUIT_PAGE: `Your changes have not been saved. Are you sure you want to leave?`,
    CANT_EDIT_INVALID_STATUS: `its status has been set to `,
    AND: `and`,
    INVALID_SHIFT_SELECTION: `You can't create a request from the shift selected in your schedule.`,
    NO_SHIFT_SELECTED: `No shift selected, please select a shift.`
  }
}
